module.exports = __webpack_public_path__ + "img/arrow-left.3c20a259.png";